import { render, staticRenderFns } from "./clinicOnLine.vue?vue&type=template&id=2e4c2650&scoped=true&"
import script from "./clinicOnLine.vue?vue&type=script&lang=js&"
export * from "./clinicOnLine.vue?vue&type=script&lang=js&"
import style1 from "./clinicOnLine.vue?vue&type=style&index=1&id=2e4c2650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c2650",
  null
  
)

export default component.exports